import { useEffect, useState } from "react";
import apiClient from "../client/ApiGetClient";
import { apiConfig } from "../authConfig";
import { useMsal } from "@azure/msal-react";

export function useGetData<T, R>(
  url: string,
  method: string,
  requestBody?: Object | FormData | string
): {
  getDataById: (formData: string) => Promise<T>;
  isProgress: boolean;
  errorMsg: Error | null;
} {
  const [isProgress, setProgress] = useState(false);
  const [errorMsg, setErrorMsg] = useState<Error | null>(null);
  const { instance, accounts } = useMsal();

  const getDataById = async (inputValue: string): Promise<T> => {
    try {
      setProgress(true);

      const data = await apiClient.sendRequest(url + `/${inputValue}`, method);

      return data;
    } catch (error: any) {
      setErrorMsg(error);
      throw error; // Re-throw the error to be caught by the caller
    } finally {
      setProgress(false);
    }
  };

  return { getDataById, isProgress, errorMsg };
}

export default useGetData;
